
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { InvoiceFormValues } from '../hooks/useInvoiceForm';
import { DollarSign } from 'lucide-react';

interface AmountFieldProps {
  form: UseFormReturn<InvoiceFormValues>;
  onCurrencyChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const AmountField: React.FC<AmountFieldProps> = ({ form, onCurrencyChange }) => {
  return (
    <FormField
      control={form.control}
      name="total"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Amount</FormLabel>
          <FormControl>
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                <DollarSign className="h-4 w-4" />
              </span>
              <Input
                {...field}
                placeholder="0.00"
                onChange={onCurrencyChange}
                inputMode="decimal"
                value={field.value}
                className="pl-9"
              />
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
